import { deviceIdGet, languageBrowser } from '@codestreet/utils'
import type { InternalAxiosRequestConfig } from 'axios'
import type { Plugin } from 'vue'

import { env } from '@/shared/config'

import { axiosClient } from './axiosClient.service'

export const apiPlugin: Plugin = {
  install() {
    axiosClient.defaults.headers['X-Application'] = env.APPLICATION
    axiosClient.defaults.headers['X-Version-Backend'] = env.VERSION_BACKEND

    axiosClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
      // @ts-expect-error -- headers is always defined on InternalAxiosRequestConfig
      if (!config.headers) config.headers = {}
      config.headers['X-Device-Id'] = deviceIdGet()
      config.headers.Locale = languageBrowser()
      return config
    })
  },
}
